<template>
  <div
    ref="birthDateChangeModal"
    id="birthDateChangeModal"
    class="modal modal-v modal-v--normal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="birthDateChangeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="birthdate-modal">
          <h2 class="birthdate-modal__title">{{ trans.get('profile:modal.birthdate_change.title') }}</h2>
          <p class="birthdate-modal__description">
            {{ trans.get('profile:modal.birthdate_change.description') }}
          </p>
          <img class="birthdate-modal__image" src="/img/viluu/background/birthdate.png" alt="coins" />
          <div>
            <h2 class="birthdate-modal__subtitle">
              {{ trans.get('profile:modal.birthdate_change.subtitle') }}
            </h2>

            <p class="birthdate-modal__hint">
              {{ trans.get('profile:modal.birthdate_change.hint') }}
            </p>
          </div>
          <div v-if="error" class="alert alert-danger">
            {{ error }}
          </div>
          <InputDate v-model="birthDate"></InputDate>
          <button type="button" class="birthdate-modal__button" @click="submitAction">
            {{ trans.get('Speichern') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InputDate from '../components/Auth/InputDate.vue';
import moment from 'moment/moment';

export default {
  name: 'BirthdateChangeModal',
  components: { InputDate },
  props: {},
  data() {
    return {
      open: false,
      error: null,
      changed: false,
      birthDate: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  watch: {
    open(val) {
      if (val) {
        $(this.$refs.birthDateChangeModal).modal('show');
        this.$nextTick(() => {
          const input = this.$refs.birthDateChangeModal.querySelector('#date');
          if (input) {
            input.addEventListener('focus', this.handleFocus);
            input.addEventListener('blur', this.handleBlur);
          }
        });
      } else {
        $(this.$refs.birthDateChangeModal).modal('hide');
      }
    },
  },
  methods: {
    handleFocus() {
      this.isInputFocused = true;
      this.birthDate = '';
    },
    handleBlur() {
      this.isInputFocused = false;
    },
    submitAction: function () {
      this.updateAction(this.birthDate)
        .then(() => {
          this.changed = true;
          this.open = false;
        });
    },
    updateAction: function (birthDate) {
      return axios
        .post('/ajax/user/birthdate', {
          'birth_date': birthDate ? moment(birthDate, 'DD MM YYYY').format('YYYY-MM-DD') : birthDate,
        });
    },
  },
  mounted() {
    let vm = this;

    $(this.$refs.birthDateChangeModal).on('hidden.bs.modal', () => {
      vm.open = false;

      if (!this.changed) {
        this.updateAction(null);
      }
    });

    // if (this.user.flags && this.user.flags.BIRTHDATE_CHANGE && this.user.flags.BIRTHDATE_CHANGE === true) {
    //   this.birthDate = moment(this.user.birth_date).format('DD MM YYYY');
    //
    //   vm.open = true;
    // }

    this.$eventHub.$on('BirthdateChangeModalOpen', () => {
      this.birthDate = moment(this.user.birth_date).format('DD MM YYYY');
      vm.open = true;
    });
  },
  beforeDestroy() {
    const input = this.$el.querySelector('#date');
    if (input) {
      input.removeEventListener('focus', this.handleFocus);
      input.removeEventListener('blur', this.handleBlur);
    }
  }

};
</script>

<style lang="scss" scoped>
@import '../../../sass/common/base/base-mixin';

.modal-dialog {
  margin: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.birthdate-modal {
  text-align: center;
  margin-bottom: 10px;

  &__title {
    text-align: center;
    color: #3b3b3b;
    font-weight: 600;
    font-size: 28px;
    line-height: 1;
  }

  &__description {
    margin-top: 10px;
    font-weight: 300;
    color: rgba(59, 59, 59, 0.8);
    line-height: 1;
    font-size: 15px;
  }

  &__subtitle {
    margin-top: 5px;
    font-size: 22px;
    color: #3b3b3b;
    font-weight: 600;
  }

  &__hint {
    margin-top: 5px;
    font-size: 14px;
    color: rgba(59, 59, 59, 0.8);
    font-weight: 300;
  }

  &__image {
    margin-top: 20px;
    padding: 0 45px;
    width: 100%;
    height: auto;
  }

  &__button {
    font-size: 22px;
    color: white;
    padding: 12px 45px;
    font-weight: 400;
    line-height: 1;
    background: linear-gradient(93.04deg, #c63e7b 0.54%, #f07b09 100%);
    border-radius: 30px;
    border: none;
    transition: 0.3s;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .form-group {
    margin-top: -15px;

    ::v-deep {
      .input-code--font-small {
        font-size: 1.6rem;
      }

      .text-danger {
        font-size: 12px;
      }
    }
  }
}
</style>
